module.exports = __webpack_public_path__ + "static/fonts/Oswald-Regular.e605f2f.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/formats/font/Oswald-Regular.ttf
// module id = 2exQ
// module chunks = 1